import { json } from "@codemirror/lang-json";
import { python } from "@codemirror/lang-python";
import { complete_keymap, default_extensions } from "@nextjournal/clojure-mode";
import { Prec, keymap } from "@uiw/react-codemirror";
import { useContext, useEffect } from "react";
import { CodeEditorContext } from "../components/editor";

export const useCodeEditor = () => {
  const ctxValue = useContext(CodeEditorContext);
  if (!ctxValue) throw new Error("Context must be defined");
  return ctxValue;
};

export const useCodeEditorPythonExtensions = () => {
  const { onSave, onRun } = useCodeEditor();

  const codeKeyMap = Prec.highest(
    keymap.of([
      {
        key: "Ctrl-s",
        preventDefault: true,
        run: () => {
          onSave();
          return true;
        },
      },
      {
        key: "Ctrl-Enter",
        preventDefault: true,
        run: () => {
          onRun();
          return true;
        },
      },
    ]),
  );
  const extensions = [codeKeyMap, python()];
  return { extensions };
};

export const useCodeEditorOqlExtensions = () => {
  const { onSave, onRun } = useCodeEditor();

  const codeKeyMap = Prec.highest(
    keymap.of([
      {
        key: "Ctrl-s",
        preventDefault: true,
        run: () => {
          onSave();
          return true;
        },
      },
      {
        key: "Ctrl-Enter",
        preventDefault: true,
        run: () => {
          onRun();
          return true;
        },
      },
      ...complete_keymap,
    ]),
  );
  const extensions = [codeKeyMap, default_extensions];
  return { extensions };
};

export const useCodeEditorJsonExtensions = () => {
  const { onSave } = useCodeEditor();
  const codeKeyMap = Prec.highest(
    keymap.of([
      {
        key: "Ctrl-s",
        preventDefault: true,
        run: () => {
          onSave();
          return true;
        },
      },
    ]),
  );
  const extensions = [codeKeyMap, json()];
  return { extensions };
};
